export default __webpack_public_path__ + "static/media/logo.55a2c0e1.jpg";